// extracted by mini-css-extract-plugin
module.exports =  {"alertIcon":"Y9jSa5","errorIcon":"fx7MAg"};